/**
 * AnonConnectionsHeader Component
 *
 * Simplified header for AnonConnectionsListPage
 * Shows just "People" title (no sort toggle for anon users)
 */
const AnonConnectionsHeader = () => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        backgroundColor: '#FFFFFF',
      }}
    >
      {/* White area for iOS status bar - fills safe-area-inset-top */}
      <div
        style={{
          height: 'env(safe-area-inset-top)',
          backgroundColor: '#FFFFFF',
        }}
      />
      {/* Header content */}
      <div
        style={{
          backgroundColor: '#FFFFFF',
          paddingTop: '12px',
          paddingBottom: '12px',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '600px',
            margin: '0 auto',
            boxSizing: 'border-box',
          }}
        >
          {/* Top Row: Page title (matches ProfileConnectionsHeader structure) */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              // 16, matching ProfileConnectionsHeader and this page's own card
              // inset — the title used to sit 4px right of the cards beneath it
              // (user: the two People pages must line up, 2026-08-16)
              paddingLeft: '16px',
              paddingRight: '16px',
            }}
          >
            {/* Page title */}
            <span
              style={{
                fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
                fontSize: '32px',
                fontWeight: '800',
                color: '#000000',
              }}
            >
              People
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnonConnectionsHeader;
